module.exports = __webpack_public_path__ + "img/youtube.039df100.svg";